import request from '@/utils/request.js'
// 批量加入购物车
export function addCartBatch(data) {
  return request({
    url: `/front/cart/batch/add`,
    method: 'POST',
    tips: 'none',
	data: data
  })
}
// 团购素材分类
export function categoryList(data) {
  return request({
    url: `/front/category/categoryList`,
    method: 'GET',
    tips: 'none',
	data: data
  })
}
// 团购商品分享
export function eventTracking(data) {
  return request({
    url: `/front/agentStatistic/eventTracking`,
    method: 'POST',
    tips: 'none',
	data: data
  })
}
// 获取拉新信息
export function newcomerActivity(data) {
  return request({
    url: `/front/newcomerActivity/invite`,
    method: 'GET',
    tips: 'none',
	data: data
  })
}

// 商品规格
export function getProductAttr(data) {
  return request({
    url: `/front/product/productAttr`,
    method: 'GET',
    tips: 'none',
	data: data
  })
}

// 店铺商品列表
export function merchantList(data) {
  return request({
    url: `/front/product/merchant/pro/list`,
    method: 'GET',
    tips: 'none',
	data: data
  })
}

// 商品详情
export function productDetail(id, data) {
  return request({
    url: `/front/product/detail/${id}`,
    method: 'GET',
    tips: 'none',
	data: data
  })
}
// 优惠券
export function couponLists(data) {
  return request({
    url: '/front/coupon/page/list',
    method: 'GET',
    tips: 'none',
    data: data
  })
}
// 优惠券-领取
export function couponReceive(data) {
  return request({
    url: `/front/coupon/receive/${data}`,
    method: 'POST',
    tips: 'none'
  })
}
// 预下单
export function preOrder(data) {
  return request({
    url: '/front/order/pre/order',
    method: 'POST',
    tips: 'none',
    data: data
  })
}
// 预下单详情
export function preOrderNo(data) {
  return request({
    url: `/front/order/load/pre/${data}`,
    method: 'GET',
    tips: 'none',
  })
}
// 计算订单价格
export function preOrderPrice(data) {
  return request({
    url: `/front/order/computed/price`,
    method: 'POST',
    tips: 'none',
	data: data
  })
}
// 加入购物车
export function addCart(data) {
  return request({
    url: `/front/cart/add`,
    method: 'POST',
    tips: 'none',
	data: data
  })
}
// 获取城市列表 
export function cityList(data) {
  return request({
    url: `/front/city/list`,
    method: 'GET',
    tips: 'none',
	data: data
  })
}
// 地址列表
export function addressList(data) {
  return request({
    url: `/front/address/list`,
    method: 'GET',
    tips: 'none',
	data: data
  })
}
// 设置默认地址
export function setDefault(id) {
  return request({
    url: `/front/address/set/default/${id}`,
    method: 'POST',
    tips: 'none'
  })
}
// 删除地址
export function addrDelete(id) {
  return request({
    url: `/front/address/delete/${id}`,
    method: 'POST',
    tips: 'none'
  })
}
// 地址详情
export function addressDetail(data) {
  return request({
    url: `/front/address/detail/${data}`,
    method: 'GET',
    tips: 'none'
  })
}
// 地址添加
export function addAddress(data) {
  return request({
    url: `/front/address/add`,
    method: 'POST',
	data: data
  })
}
// 编辑添加
export function editAddress(data) {
  return request({
    url: `/front/address/edit`,
    method: 'POST',
	data: data
  })
}

// 创建订单
export function createOrder(data) {
  return request({
    url: `/front/order/create`,
    method: 'POST',
	data: data
  })
}
// 订购人列表
export function subscriberRecord(data) {
  return request({
    url: `/front/subscriberRecord/list`,
    method: 'GET',
    tips: 'none',
	data: data
  })
}
// 添加订购人
export function subscriberRecordAdd(data) {
  return request({
    url: `/front/subscriberRecord/add`,
    method: 'POST',
    tips: 'none',
	data: data
  })
}
// 删除订购人
export function subscriberRecordDelete(data) {
  return request({
    url: `/front/subscriberRecord/delete`,
    method: 'POST',
    tips: 'none',
	data: data
  })
}

// 购物车列表
export function cartList(data) {
  return request({
    url: `/front/cart/list`,
    method: 'GET',
    tips: 'none',
	data: data
  })
}
// 修改数量
export function cartNum(data) {
  return request({
    url: `/front/cart/num`,
    method: 'POST',
    tips: 'none',
	data: data
  })
}
// 购物车列表
export function cartPrice(data) {
  return request({
    url: `/front/cart/calculate/price`,
    method: 'POST',
    tips: 'none',
	data: data
  })
}
// 购物车选中
export function cartChecked(data) {
  return request({
    url: `/front/cart/checked`,
    method: 'POST',
    tips: 'none',
	data: data
  })
}
// 购物车列表
export function cartDelete(data) {
  return request({
    url: `/front/cart/delete`,
    method: 'POST',
    tips: 'none',
	data: data
  })
}
// 购物车活动详情
export function activityDetail(activityId) {
  return request({
    url: `/front/activity/activityRule/${activityId}`,
    method: 'GET',
    tips: 'none'
  })
}
// 拼团商品列表 
export function groupbuySkuProductList(data) {
  return request({
    url: `/front/groupbuy/sku/product/list`,
    method: 'GET',
    tips: 'none',
	data: data
  })
}
// 拼团订单中查看拼团活动 - 用于分享 (自己购买过)
export function groupbuySkuOrderShare(orderNo) {
  return request({
    url: `/front/groupbuy/sku/order/share/${orderNo}`,
    method: 'GET',
    tips: 'none',
  })
}
// 拼团订单中查看拼团活动 - 用于参团 (自己还没购买)
export function groupbuySkuOrderReadshare(groupActivityId, productId, recordId) {
  return request({
    url: `/front/groupbuy/sku/order/readshare/${groupActivityId}/${productId}/${recordId}`,
    method: 'GET',
    tips: 'none',
  })
}